import { type RouteLocationNormalized, type RouteRecordRaw } from 'vue-router'

export const pipelineRunRouter: RouteRecordRaw[] = [
  {
    component: async () =>
      await import('../components/editors/menu/MenuPipelineRun.vue'),
    name: 'pipelineRun',
    path: 'pipeline-run/:menuId/:runId',
    props: (route: RouteLocationNormalized) => ({
      menuId: route.params.menuId,
      mostRecentRunId: route.query.mostRecentRunId,
      runId: route.params.runId,
    }),
  },
]
